const shouldUsePolyfill = () => {
    const objectAssign = typeof Object.assign !== "function";
    const arrayIncludes = !Array.prototype.includes;
    const arrayFrom = !Array.prototype.from;
    const numberIsInteger = !Number.isInteger;
    const windowFetch = !window.fetch;

    return (
        objectAssign ||
        arrayIncludes ||
        arrayFrom ||
        numberIsInteger ||
        windowFetch
    );
};

const init = () => {
    // Polyfills are loaded in a all or nothing order
    // If one polyfill is needed we load them all

    if (!shouldUsePolyfill()) {
        return Promise.resolve();
    }

    return import(/* webpackChunkName: "polyfills" */ "@/utilities/polyfills/polyfills").then(
        myModule => {
            return myModule.default;
        }
    );
};

export default init;
